/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-11-28 10:40:08
 * @LastEditors: 周志国
 * @LastEditTime: 2025-12-01 15:44:23
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Poi/panel/utils.ts
 */
/**
 * 将任意对齐值规范化为 'left' | 'center' | 'right'。
 * @param v 任意字符串
 * @returns 'left' | 'center' | 'right'
 */
function clampAlign(v) {
  if (v === 'center')
    return 'center'
  if (v === 'right')
    return 'right'
  return 'left'
}

/**
 * 将任意字重值规范化为 'normal' 或 'bold'。
 * @param v 任意字符串
 * @returns 'normal' | 'bold'
 */
function parseWeight(v) {
  if (v === 'bold')
    return 'bold'
  return 'normal'
}

/**
 * 将任意字体风格规范化为 'normal' 或 'italic'。
 * @param v 任意字符串
 * @returns 'normal' | 'italic'
 */
function parseStyle(v) {
  if (v === 'italic')
    return 'italic'
  return 'normal'
}

/**
 * 将输入转为数字；若无效则回退到默认值。
 * @param n 任意值
 * @param d 默认值
 * @returns 有效数字
 */
function num(n, d = 0) {
  if (typeof n === 'number' && !Number.isNaN(n))
    return n
  return d
}

/**
 * 返回有效的颜色字符串；若无效则回退到默认值。
 * @param c 任意值
 * @param d 默认颜色，默认为 `#ffffff`
 * @returns 颜色字符串
 */
function color(c, d = '#ffffff') {
  if (typeof c === 'string' && c.length)
    return c
  return d
}

/**
 * 清理 URL 字符串，去除反引号并修剪空白。
 * @param u 任意值
 * @returns 清理后的 URL 字符串（无效时返回空串）
 */
function sanitizeUrl(u: any): string {
  if (typeof u !== 'string')
    return ''
  // 去掉意外的反引号并修剪空白
  return u.replace(/`/g, '').trim()
}

/**
 * 解析长度至少为 2 的数组，缺省回退到默认值。
 * @param a 任意数组
 * @param d 默认值 `[x, y]`
 * @returns `[x, y]`
 */
function arr2(a, d = [0, 0]) {
  if (Array.isArray(a) && a.length >= 2)
    return [num(a[0], d[0]), num(a[1], d[1])]
  return d
}

/**
 * 解析长度至少为 4 的数组，缺省回退到默认值。
 * @param a 任意数组
 * @param d 默认值 `[t, r, b, l]`
 * @returns `[t, r, b, l]`
 */
function arr4(a, d = [0, 0, 0, 0]) {
  if (Array.isArray(a) && a.length >= 4)
    return [num(a[0], d[0]), num(a[1], d[1]), num(a[2], d[2]), num(a[3], d[3])]
  return d
}
/**
 * 解析长度至少为 3 的数组，缺省回退到默认值。
 * @param a 任意数组
 * @param d 默认值 `[h, s, l]`
 * @returns `[h, s, l]`
 */
function arr3(a, d = [0, 0, 0]) {
  if (Array.isArray(a) && a.length >= 3)
    return [num(a[0], d[0]), num(a[1], d[1]), num(a[2], d[2])]
  return d
}

/**
 * 规范化九宫格边框的平铺模式。
 * @param v 'repeat' | 'round' | 其他
 * @returns 'repeat' | 'round' | 'stretch'
 */
function rep(v) {
  if (v === 'repeat' || v === 'round')
    return v
  return 'stretch'
}

/**
 * 批量应用内联样式到元素。
 * @param el 目标元素
 * @param styles 样式键值对
 */
function setStyles(el: HTMLElement, styles: Record<string, string>) {
  Object.assign(el.style, styles)
}
export { clampAlign, parseWeight, parseStyle, num, color, sanitizeUrl, arr2, arr3, arr4, rep, setStyles }
